<template>
  <div class="message-page">
    <van-nav-bar class="message-header" :title="$t('Message Center')" left-arrow @click-left="$router.back()" />
    <div style="height: 60px"></div>
    <div class="van-tabs-view van-tabs">
      <div class="van-tabs__wrap" style="margin: 0 15px">
        <div role="tablist" class="van-tabs__nav van-tabs__nav--card">
          <div role="tab" @click="changType(1)" aria-selected="true" :class="type == 1 ? 'van-tab van-tab--active' : 'van-tab'">
            <span class="van-tab__text van-tab__text--ellipsis">{{ $t('Announcements') }}</span>
          </div>
          <div role="tab" @click="changType(2)" :class="type == 2 ? 'van-tab van-tab--active' : 'van-tab'">
            <span class="van-tab__text van-tab__text--ellipsis">{{ $t('Inbox') }}</span>
          </div>
        </div>
      </div>
      <div class="van-tabs__content" style="width: 90%; margin: 0 auto; padding-top: 20px">
        <div v-if="type == 1" role="tabpanel" class="van-tab__pane" style="">
          <van-list :finished-text="$t('No more')" :finished="true" v-if="homenoticelis.length > 0">
            <van-cell v-for="item in homenoticelis" :key="item.id" class="message-card">
              <h3 class="message-title">{{ item.name || item.title }}</h3>
              <div class="message-content" v-html="item.content"></div>
              <div v-if="item.created_at" class="message-time">{{ item.created_at }}</div>
            </van-cell>
          </van-list>
          <van-divider v-else dashed :style="{ color: '#aaa', borderColor: '#ddd', padding: '20px 80px' }">{{ $t('No more') }}</van-divider>
        </div>
        <div v-if="type == 2" role="tabpanel" class="van-tab__pane">
          <van-list :finished-text="$t('No more')" offset="300" v-model="loading" :finished="messageFinished" @load="getDatalist" v-if="noticeList.length > 0">
            <van-cell v-for="item in noticeList" :key="item.id" class="message-card">
              <h3 class="message-title">{{ item.title }}</h3>
              <div class="message-content" v-html="item.content"></div>
              <div v-if="item.created_at" class="message-time">{{ item.created_at }}</div>
            </van-cell>
          </van-list>
          <van-divider v-else dashed :style="{ color: '#aaa', borderColor: '#ddd', padding: '20px 80px' }">{{ $t('No more') }}</van-divider>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'message',
  data() {
    return {
      type: 1,
      noticeList: [],
      homenoticelis: [],
      noticeListInfo: {},
      page: 1,
      loading: false,
      messageFinished: false,
    };
  },
  created() {
    let that = this;
    var query = that.$route.query;
    if (query.type) {
      that.type = query.type * 1;
    }

    that.homenotice();
    that.getDatalist();
  },
  methods: {
    changType(type) {
      let that = this;
      that.type = type;
    },
    homenotice() {
      let that = this;
      that.$parent.showLoading();
      that.$apiFun.post('/api/homenotice', {}).then(res => {
        if (res.code != 200) {
          that.showTost(0, res.message);
        }
        if (res.code == 200) {
          that.homenoticelis = res.data;
        }
        that.$parent.hideLoading();
      });
    },
    getDatalist() {
      let that = this;
      let page = that.page;
      if (that.messageFinished) {
        that.loading = false;
        return;
      }
      that.loading = true;
      that.$parent.showLoading();
      that.$apiFun
        .post('/api/noticeList', { page })
        .then(res => {
          if (res.code != 200) {
            that.$parent.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.noticeListInfo = res.data || {};
            const rows = Array.isArray(that.noticeListInfo.data) ? that.noticeListInfo.data : [];
            that.noticeList = page == 1 ? rows : that.noticeList.concat(rows);
            that.page = page + 1;
            that.messageFinished =
              !rows.length ||
              Number(that.noticeListInfo.current_page || page) >= Number(that.noticeListInfo.last_page || page);
          }
          that.loading = false;

          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
  },
  mounted() {
    let that = this;
  },
  updated() {
    let that = this;
  },
  beforeDestroy() {},
};
</script>
<style lang="scss" scoped>
.message-page {
  min-height: 100vh;
  background: #f7f8fa;
}
.message-header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  background: url(/img/counter/top-bg.webp) no-repeat rgb(8, 76, 203);
}
.van-tabs__nav--card .van-tab.van-tab--active {
  color: #1989fa;
  background-color: #fff;
}
.van-tabs__nav--card {
  border: 1px solid #ffffff;
}
.van-tabs__nav--card .van-tab {
  color: #333;
}
.van-tabs__nav--card .van-tab {
  border-right: 0 solid #cf866b;
}
.message-card {
  margin-bottom: 10px;
  border-radius: 10px;
  box-shadow: 0 2px 10px rgba(30, 60, 100, 0.06);
}
.message-title {
  margin: 0 0 8px;
  color: #252b36;
  font-size: 16px;
  font-weight: 600;
}
.message-content {
  color: #555f6f;
  font-size: 14px;
  line-height: 1.6;
  overflow-wrap: anywhere;
}
.message-content ::v-deep p {
  margin: 0;
}
.message-time {
  margin-top: 8px;
  color: #a0a8b5;
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/message.vue